export default function CTA() {
  return (
    <section className="w-full bg-gradient-to-b from-cyan-100 via-cyan-200 to-blue-900">
      <div className="min-h-[540px] relative flex items-center justify-center px-6 py-12 lg:py-0">
        {/* Decorative Stars */}
        <svg
          className="absolute top-8 right-20 w-8 h-10 text-yellow-400"
          viewBox="0 0 31 40"
          fill="currentColor"
        >
          <path d="M18.57 10.5245C19.2298 14.0691 20.655 17.5377 23.0781 19.8136C25.1936 21.8021 27.8797 22.7286 30.4883 23.61C26.5108 22.7025 22.2657 24.1826 19.11 27.1475C15.9544 30.1124 13.8553 34.4529 12.9138 39.0499C13.6863 34.6905 12.2516 30.0388 9.67123 26.7603C7.12135 23.5198 3.61351 21.574 0 20.5097C11.5261 21.4624 13.9891 10.5506 17.9384 0C17.9947 3.51371 17.9267 7.06068 18.57 10.5245Z" />
        </svg>

        <svg
          className="absolute bottom-32 right-32 w-8 h-10 text-yellow-400"
          viewBox="0 0 31 40"
          fill="currentColor"
        >
          <path d="M18.57 10.5245C19.2298 14.0691 20.655 17.5377 23.0781 19.8136C25.1936 21.8021 27.8797 22.7286 30.4883 23.61C26.5108 22.7025 22.2657 24.1826 19.11 27.1475C15.9544 30.1124 13.8553 34.4529 12.9138 39.0499C13.6863 34.6905 12.2516 30.0388 9.67123 26.7603C7.12135 23.5198 3.61351 21.574 0 20.5097C11.5261 21.4624 13.9891 10.5506 17.9384 0C17.9947 3.51371 17.9267 7.06068 18.57 10.5245Z" />
        </svg>

        <svg
          className="absolute bottom-48 left-16 w-8 h-10 text-yellow-400"
          viewBox="0 0 31 40"
          fill="currentColor"
        >
          <path d="M18.57 10.5245C19.2298 14.0691 20.655 17.5377 23.0781 19.8136C25.1936 21.8021 27.8797 22.7286 30.4883 23.61C26.5108 22.7025 22.2657 24.1826 19.11 27.1475C15.9544 30.1124 13.8553 34.4529 12.9138 39.0499C13.6863 34.6905 12.2516 30.0388 9.67123 26.7603C7.12135 23.5198 3.61351 21.574 0 20.5097C11.5261 21.4624 13.9891 10.5506 17.9384 0C17.9947 3.51371 17.9267 7.06068 18.57 10.5245Z" />
        </svg>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full max-w-6xl items-center relative z-10">
          {/* Left: Astronaut Image */}
          <div className="flex justify-center lg:justify-start">
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/2b8573aeb4015a4ef7297515d1560975ea253734?width=978"
              alt="HOLE Astronaut"
              className="w-full max-w-sm h-auto"
            />
          </div>

          {/* Right: Content & Logo */}
          <div className="space-y-8 flex flex-col items-center lg:items-start text-center lg:text-left">
            {/* HOLE Foundation Logo */}
            <div>
              <img
                src="https://cdn.builder.io/api/v1/image/assets%2F566ec6565eb24d30bb5444f54ebc4f01%2F34ea96d58d7a4aeab69834bbaa989b51?format=webp&width=800"
                alt="HOLE Logo"
                className="h-12 w-auto"
              />
            </div>

            {/* Maintenance Message */}
            <div className="space-y-4">
              <h2 className="font-agency text-h2 font-bold text-white">
                Maintenance Underway
              </h2>
              <p className="font-kepler text-text-lg-custom text-white font-bold">
                We're busy adding new features.
                <br />
                Standby for launch
              </p>
            </div>

            {/* CTA Button - Optional */}
            <button className="mt-4 px-8 py-3 bg-brand-orange text-white font-bold rounded hover:bg-orange-600 transition-colors font-agency text-text-md-custom">
              Join the Movement
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
